if (!customElements.get('product-choice-selector')) {
  customElements.define(
    'product-choice-selector',
    class ProductChoiceSelector extends HTMLElement {
      connectedCallback() {
        this.productForm = document.getElementById(this.dataset.formId);
        if (!this.productForm) return;

        this.trigger = this.querySelector('[data-pc-trigger]');
        this.dropdown = this.querySelector('[data-pc-dropdown]');
        this.selectedText = this.querySelector('[data-pc-selected]');
        this.pcOptions = this.querySelectorAll('[data-pc-option]');
        this.optOutItem = this.querySelector('[data-pc-optout]');
        this.selectedVariantId = null;
        this.isOptedOut = false;

        this.trigger?.addEventListener('click', () => this.toggleDropdown());

        this.pcOptions.forEach((opt) => {
          opt.addEventListener('click', () => this.selectOption(opt));
        });

        this.optOutItem?.addEventListener('click', () => this.handleOptOut());

        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) this.closeDropdown();
        });

        this.addEventListener('keydown', (e) => this.handleKeydown(e));

        if (this.dataset.required === 'true') {
          this.productForm.addEventListener('submit', (e) => this.validateSubmit(e), {
            capture: true,
          });
        }
      }

      toggleDropdown() {
        this.dropdown.classList.contains('is-open') ? this.closeDropdown() : this.openDropdown();
      }

      openDropdown() {
        this.dropdown.classList.add('is-open');
        this.trigger?.setAttribute('aria-expanded', 'true');
      }

      closeDropdown() {
        this.dropdown.classList.remove('is-open');
        this.trigger?.setAttribute('aria-expanded', 'false');
      }

      selectOption(item) {
        this.pcOptions.forEach((o) => o.removeAttribute('aria-selected'));
        item.setAttribute('aria-selected', 'true');

        this.selectedVariantId = item.dataset.variantId;
        this.isOptedOut = false;

        if (this.selectedText) {
          this.selectedText.textContent =
            item.dataset.label ||
            item.querySelector('.product-picker__item-title')?.textContent.trim() ||
            item.textContent.trim();
        }

        this.applyFormInputs();
        this.setError(false);
        this.trigger?.classList.add('has-value');
        this.closeDropdown();
      }

      handleOptOut() {
        this.pcOptions.forEach((o) => o.removeAttribute('aria-selected'));
        this.selectedVariantId = null;
        this.isOptedOut = true;

        if (this.selectedText && this.optOutItem) {
          this.selectedText.textContent = this.optOutItem.textContent.trim();
        }

        this.removeFormInputs();
        this.setError(false);
        this.trigger?.classList.add('has-value');
        this.closeDropdown();
      }

      applyFormInputs() {
        this.removeFormInputs();

        const idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = `items[0][id]`;
        idInput.value = this.selectedVariantId;
        idInput.classList.add('product-choice__id-input');
        idInput.setAttribute('data-pc-input', '');
        idInput.setAttribute('data-pc-id', this.dataset.id);

        const qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = `items[0][quantity]`;
        qtyInput.value = '1';
        qtyInput.setAttribute('data-pc-input', '');
        qtyInput.setAttribute('data-pc-id', this.dataset.id);

        this.productForm.appendChild(idInput);
        this.productForm.appendChild(qtyInput);

        const existingIdInputs = this.productForm.querySelectorAll('.product-choice__id-input');

        existingIdInputs.forEach((el, index) => {
          el.name = `items[${index}][id]`;
          el.nextElementSibling.name = `items[${index}][quantity]`;
        });
      }

      removeFormInputs() {
        this.productForm.querySelectorAll(`[data-pc-input][data-pc-id="${this.dataset.id}"]`).forEach((el) => el.remove());
      }

      validateSubmit(event) {
        if (this.isOptedOut || this.selectedVariantId) return;

        event.stopImmediatePropagation();
        event.preventDefault();

        this.setError(true);

        if (typeof this.productForm.displayFormErrors === 'function') {
          this.productForm.displayFormErrors(this.dataset.errorMessage);
        } else {
          const errEl = this.productForm.querySelector('.product-form__error-message');
          if (errEl) {
            errEl.textContent = this.dataset.errorMessage;
            errEl.removeAttribute('hidden');
            errEl.closest('.product-form__error-message-wrapper')?.removeAttribute('hidden');
          }
        }
      }

      setError(hasError) {
        this.classList.toggle('has-error', hasError);
        if (!hasError) {
          if (typeof this.productForm.displayFormErrors === 'function') {
            this.productForm.displayFormErrors();
          } else {
            const errEl = this.productForm.querySelector('.product-form__error-message');
            if (errEl) {
              errEl.setAttribute('hidden', '');
              errEl.closest('.product-form__error-message-wrapper')?.setAttribute('hidden', '');
            }
          }
        }
      }

      handleKeydown(e) {
        const isOpen = this.dropdown.classList.contains('is-open');
        switch (e.key) {
          case 'Enter':
          case ' ':
            if (!isOpen) this.openDropdown();
            break;
          case 'Escape':
            this.closeDropdown();
            this.trigger?.focus();
            break;
          case 'ArrowDown': {
            e.preventDefault();
            if (!isOpen) this.openDropdown();
            const allItems = [...this.pcOptions, ...(this.optOutItem ? [this.optOutItem] : [])];
            const currentIdx = allItems.findIndex((o) => o.hasAttribute('aria-selected'));
            const next = allItems[currentIdx + 1];
            if (next) next.click();
            break;
          }
          case 'ArrowUp': {
            e.preventDefault();
            const allItems = [...this.pcOptions, ...(this.optOutItem ? [this.optOutItem] : [])];
            const currentIdx = allItems.findIndex((o) => o.hasAttribute('aria-selected'));
            const prev = allItems[currentIdx - 1];
            if (prev) prev.click();
            break;
          }
        }
      }
    }
  );
}
